import get from 'lodash/fp/get.js';
import isUndefined from 'lodash/fp/isUndefined.js';
import { connect } from 'react-redux';
import { arrayPush } from 'redux-form';
import { OCCUPANCY_BY_STORY } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import OccupancyFieldset from './OccupancyFieldset.jsx';

const mapStateToProps = (state, ownProps) => {
  const { form } = ownProps;
  const { fieldsByName, selectFormFieldVisibility } = modelTypesByForm[form];
  const modelTypeSupportsDefineByStory = !isUndefined(get(OCCUPANCY_BY_STORY, fieldsByName));
  return {
    defineByStory:
      modelTypeSupportsDefineByStory && !!selectFormFieldVisibility(state)(OCCUPANCY_BY_STORY),
    supportDefineByStory: modelTypeSupportsDefineByStory,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { form } = ownProps;
  const { fieldsByName } = modelTypesByForm[form];
  const modelTypeSupportsDefineByStory = !isUndefined(get(OCCUPANCY_BY_STORY, fieldsByName));
  return {
    afterToggleOn: () => {
      if (modelTypeSupportsDefineByStory) {
        dispatch(arrayPush(form, OCCUPANCY_BY_STORY, {}));
      }
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OccupancyFieldset);
